<template>
  <modal style="display:none"  name="print-modal"
  @opened="print()" 
>
    <div id="printMe">
      <!-- odcinek dla klienta -->
      <div class="container">
        <div class="row" style="padding-top:25px;">
          <div class="col-sm">
            <div>
              {{oneTask.userAddress}}
              <br />
              Tel.:{{oneTask.userPhoneOne}}
              Tel.:{{oneTask.userPhoneTwo}}
              <br />Email: {{oneTask.userCompanyEmail}}
              <br />
              <br />GODZINY OTWARCIA:
              <br />Poniedziałek-Piątek: 9:00-17:00
              <br />Sobota: 9:00-13:00
            </div>
          </div>

          <div class="col-sm">
            <h6 style="margin-top:50px;">Numer Zlecenia: {{oneTask.taskId}}/{{oneTask.createdOn | formatDate}}</h6>
          </div>

          <div class="col-sm">
            <img src="../assets/zicobikelogo.png" />
          </div>
        </div>
        <hr>
        <div class="row" style="padding:10px;">
          <div class="col-sm">
            <div>
              <h5>Dane klienta:</h5>
            </div>
            <div class="text-left">
              <div>Imię: {{oneTask.title}}</div>
              <div>
                Numer kontaktowy:
                <b>{{oneTask.phone}}</b>
              </div>
              <div>Adres: {{oneTask.address}}</div>
            </div>
          </div>

          <div class="col-sm">
            <div>
              <h5>Rower:</h5>
            </div>
            <div class="text-left">
              <div>
                <!-- Marka: -->
                <b>{{oneTask.bike}}</b>
              </div>
              <!-- <div>
                Numer ramy:
                <b>{{oneTask.frame}}</b>
              </div> -->
            </div>
          </div>

          <div class="col-sm">
            <div>
              <h5>Przyjmujący:</h5>
            </div>
            <div>{{oneTask.userName}} {{oneTask.userTitle}}</div>
          </div>
        </div>
        <hr>
        <div class="row" style="padding:10px;">
          <div class="col-sm">
            <h5>Opis usterki:</h5>
            <div style="border:1px solid black; padding:30px; margin-top:15px">{{oneTask.content}}</div>
          </div>
        </div>

        <div class="row" style="margin-top:10px; padding:10px;">
          <div class="col-sm">
            <div class="text-right">Podpis oraz pieczątka:</div>
            <div
              class="text-right"
              style="border:1px solid black;float:right;width:250px;height:125px;margin-top:5px;"
            ></div>
          </div>
        </div>
      </div>
      <!-- odcinek na serwis -->
      <div class="container" style="border-top:2px dotted black;margin-top:25px;">
        <div class="row">
          <div class="col-sm text-center" style="margin-top:20px;">
            <h5>Odcinek dla serwisu: {{oneTask.title}}</h5>
          </div>
            <div class="col-sm">
            <h6 style="margin-top:20px;">Numer Zlecenia: {{oneTask.taskId}}/{{oneTask.createdOn | formatDate}}</h6>
          </div>
        </div>

        <div class="row" style="margin-top:20px; padding:10px;">
          <div class="col-sm">
            <div>
              <h5>Dane klienta:</h5>
            </div>
            <div class="text-left">
              <div>Imię: {{oneTask.title}}</div>
              <div>
                Numer kontaktowy:
                <b>{{oneTask.phone}}</b>
              </div>
              <div>Adres: {{oneTask.address}}</div>
            </div>
          </div>

          <div class="col-sm">
            <div>
              <h5>Rower:</h5>
            </div>
            <div class="text-left">
              <div>
                Marka:
                <b>{{oneTask.bike}}</b>
              </div>
              <div>
                Numer ramy:
                <b>{{oneTask.frame}}</b>
              </div>
            </div>
          </div>

          <div class="col-sm">
            <div>
              <h5>Przyjmujący:</h5>
            </div>
            <div>{{oneTask.userName}} {{oneTask.userTitle}}</div>
          </div>
        </div>
        <hr>
        <div class="row" style="margin-top:10px; padding:10px;">
          <div class="col-sm">
            <h5>Opis usterki:</h5>
            <div style="border:1px solid black; padding:30px; margin-top:15px">{{oneTask.content}}</div>
          </div>
        </div>

        <div class="row" style="margin-top:10px; padding:10px;">
          <div class="col-sm">
            <div>Uwagi dla klienta:</div>
            <div style="border:1px solid black;padding:30px; height:150px;margin-top:5px;">{{oneTask.clientComment}}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- OUTPUT -->
  </modal>
</template>
 

<script>
import moment from 'moment'
export default {
  data() {
    return {
      output: null,
    };
  },
  props: ["oneTask"],

  methods: {
    print() {
      // Pass the element id here
      this.$htmlToPaper("printMe");
      this.$modal.hide('print-modal')
    },
  },
  filters: {
      formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      moment.locale("en");
      return moment(date).format('L');
    },
  }

};
</script>